import Vue from 'vue/dist/vue.esm'
import each from 'lodash/each'
import createStore from 'stores/storefront/top-selling-fragrances/data-store.js'
import TopSellingFragrances from 'components/storefront/top-selling-fragrances.vue'

export default function buildTopSellingFragrancesByStateApp(element, csStateFragranceData) {
  new Vue({
    el: element,
    store: createStore(csStateFragranceData),
    components: {
      TopSellingFragrances
    }
  })

  // preload images
  each(csStateFragranceData, (value) => {
    if (value.flag_image) {
      const flagImage = new Image()
      flagImage.src = value.flag_image
    }
  })
}
